import { putSonarObjectStakeholders } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../../initiatives/summary/get';
import { updateSonarObjectReferences } from '../_idMap/actions';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const putCoreSonarObjectsStakeholdersSlice = createPutAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Latest
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences([
					{
						sonarObjectId: request.sonarObjectId,
						stakeholders: request.stakeholderIds
					}
				])
		]
	},
	name: 'CoreSonarObjectsStakeholders',
	receive: false,
	request: true,
	requestHandler: putSonarObjectStakeholders
});
